import { render, staticRenderFns } from "./SelectShipAddress.vue?vue&type=template&id=94ea4f88&"
import script from "./SelectShipAddress.vue?vue&type=script&lang=ts&"
export * from "./SelectShipAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94ea4f88')) {
      api.createRecord('94ea4f88', component.options)
    } else {
      api.reload('94ea4f88', component.options)
    }
    module.hot.accept("./SelectShipAddress.vue?vue&type=template&id=94ea4f88&", function () {
      api.rerender('94ea4f88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Product/SelectShipAddress.vue"
export default component.exports